import Assert from 'Common/Assert';

/*
	Reads the value from an input field and returns it as a string.  
	Returns null if it is not present or there is an empty string (after trimming). 
	Booleans will be converted to 'true' or 'false'.
	Strings are auto-trimmed.
	IF WE DONT WANT auto-trim or auto-nulling in some circumstance I think it would be best to
	add an option to the NJK input macro, allowing it to be disabled. FieldTypes can be
	used with different types of inputs, so its not great dealing with it there.
 */
export function getInputString(node:HTMLElement):string|null
{
	Assert.property('value',node);
	const value = (<any>node).value.trim();
	return value=='' ? undefined : value;
}

export function processInput(inputType,value:string|boolean)
{
	/* Checkboxes return booleans */
	if (typeof value == 'boolean')
		return value;

	const trimmed = value?.trim();
	if (trimmed=='' || trimmed==null)
		return null;		//TODO probably should use undefined

	/* This is included for the convenience of the caller */
	if (inputType==null)
		return trimmed;

	return inputType.input(value);
}

